import { SystemStyleObject } from '@chakra-ui/react';

export const getStyles = (
  activeIcon: boolean,
  isCompact = false,
  sx: any = {}
) => {
  const activeHoveredLinkSX: SystemStyleObject = {
    ' p:first-of-type': {
      fontWeight: 600,
    },
    ...(activeIcon
      ? {
          ' svg': {
            display: 'none',
            '&.active': {
              display: 'block',
            },
          },
        }
      : {}),
  };

  const { _activeLink, ...overrideLinkSx } = sx;
  const linkSx: SystemStyleObject = {
    display: 'flex',
    h: '28px',
    w: isCompact ? 'fit-content' : 'full',
    mx: isCompact ? 'auto' : 0,
    textDecor: 'none',
    color: 'M.60',
    px: 2,
    rounded: 2,
    _hover: {
      textDecor: 'none',
      color: 'M.70',
      bg: 'surface2',
      ...activeHoveredLinkSX,
    },
    _focus: { textDecor: 'none' },
    _activeLink: {
      color: 'M.70',
      bg: 'surface2',
      ...activeHoveredLinkSX,
      ..._activeLink,
    },
    _focusVisible: {
      boxShadow: 'none',
    },
    ...overrideLinkSx,
  };

  const wrapperSx: SystemStyleObject = {
    overflow: 'hidden',
    '& svg': {
      flexShrink: 0,
      '&.active': {
        display: 'none',
      },
    },
    alignItems: 'center',
  };

  const iconSx: SystemStyleObject = {
    w: 4,
    h: 4,
  };

  const primaryLabelSx: SystemStyleObject = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: 'inherit',
  };

  const secondaryLabelSx: SystemStyleObject = {
    fontSize: '2xs',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: 'M.60',
  };

  return {
    linkSx,
    wrapperSx,
    iconSx,
    primaryLabelSx,
    secondaryLabelSx,
  };
};
